import React from 'react';

const styles = {
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '20px'
  },
  th: {
    borderBottom: '2px solid #ddd',
    padding: '12px',
    textAlign: 'left',
    backgroundColor: '#f2f2f2'
  },
  td: {
    borderBottom: '1px solid #ddd',
    padding: '12px'
  },
  pagination: {
    marginTop: '20px',
    textAlign: 'right'
  },
  button: {
    padding: '8px 16px',
    margin: '0 5px',
    cursor: 'pointer'
  }
};

const Table = ({ headers, data, renderRow, pagination }) => {
  const { page, setPage, total, limit } = pagination;
  const totalPages = Math.ceil(total / limit);

  return (
    <div>
      <table style={styles.table}>
        <thead>
          <tr>
            {headers.map(header => (
              <th key={header.key} style={styles.th}>
                {header.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data
            .slice(page * limit, page * limit + limit)
            .map((item, index) => renderRow(item, index))}
        </tbody>
      </table>
      {totalPages > 1 && (
        <div style={styles.pagination}>
          {/* eslint-disable-next-line react/button-has-type */}
          <button
            style={styles.button}
            onClick={() => setPage(p => Math.max(0, p - 1))}
            disabled={page === 0}
          >
            Previous
          </button>
          <span>
            Page {page + 1} of {totalPages}
          </span>
          {/* eslint-disable-next-line react/button-has-type */}
          <button
            style={styles.button}
            onClick={() => setPage(p => Math.min(totalPages - 1, p + 1))}
            disabled={page === totalPages - 1}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default Table;
